var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.length)?_c('grid-stack',{attrs:{"data":_vm.data,"customizeSizing":_vm.customizeSizing}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }